export const ACTIONS = {
  SUBMIT: "submit",
  SUBMIT_SUCCESS: "success",
  SUBMIT_FAILURE: "failure",
  RESET: "reset",
};

export const STATUS = {
  READY: "ready",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};

export default function formReducer(state, action) {
  switch (action.type) {
    case ACTIONS.SUBMIT:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case ACTIONS.SUBMIT_SUCCESS:
      return {
        ...state,
        status: STATUS.SUCCESS,
        message: action.payload,
      };
    case ACTIONS.SUBMIT_FAILURE:
      return {
        ...state,
        status: STATUS.ERROR,
        message: action.payload,
      };
    case ACTIONS.RESET:
      return {
        ...state,
        status: STATUS.READY,
        message: null,
      };
    default:
      return state;
  }
}
